var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"front"},[_c('Header'),_c('main',[_c('router-view')],1),_c('div',{staticClass:"footer__text"},[_vm._v("NFT TSUNAMI IS HERE")]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }